import React from 'react';

const DescriptiveText = ({ included }) => (
  <span>{included}</span>
);

export default DescriptiveText;